var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2552 2.91797H1.75521C1.43304 2.91797 1.17188 3.17914 1.17188 3.5013V11.0846C1.17188 11.4068 1.43304 11.668 1.75521 11.668H12.2552C12.5774 11.668 12.8385 11.4068 12.8385 11.0846V3.5013C12.8385 3.17914 12.5774 2.91797 12.2552 2.91797Z",
    stroke: "#8B93A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 1.75V4.08333",
    stroke: "#8B93A7",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28646 6.70703H4.07812",
    stroke: "#8B93A7",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91146 9.04297H4.07812",
    stroke: "#8B93A7",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92188 1.75V4.08333",
    stroke: "#8B93A7",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.a02a9578b59e5b75b1b66b56520a954b.svg";
export { ForwardRef as ReactComponent };